export const fromContacts = contacts =>
  contacts.map(contact => ({
    value: contact.id,
    label: contact.firstName + ' ' + contact.lastName,
    email: contact.email
  }))
